import React from "react";
import { Box, Container, Typography } from "@mui/material";
import privacyPolicy from "../data/privacy-policy";

const PrivacyPolicyPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 12, mb: 12 }}>
      <Typography variant="h3" component="h1" gutterBottom>
        {privacyPolicy.title}
      </Typography>
      <Typography variant="body1" gutterBottom sx={{ mb: 4 }}>
        {privacyPolicy.lastUpdated}
      </Typography>

      {privacyPolicy.sections.map((section, idx) => (
        <Box key={idx} sx={{ mb: 4 }}>
          <Typography variant="h6" component="h2" gutterBottom>
            {section.heading}
          </Typography>
          {section.content.map((paragraph, pIdx) => (
            <Typography key={pIdx} variant="body1">
              {paragraph}
            </Typography>
          ))}
        </Box>
      ))}
    </Container>
  );
};

export default PrivacyPolicyPage;
